(() => {
  const selector =
    'main[data-template="product"] [id^="ProductInformation-"] .rte table';

  function enhanceSizeTables() {
    document.querySelectorAll(selector).forEach((table) => {
      if (table.dataset.auvessiaResponsive === 'true') return;

      const headerRow = table.tHead?.rows?.[0] || table.rows?.[0];
      if (!headerRow) return;

      const headings = Array.from(
        headerRow.cells,
        (cell) => cell.textContent.trim()
      );

      /* Alleen tabellen waarvan de eerste kolom Size is */
      if (!/^size(?:\s|$)/i.test(headings[0] || '')) return;

      table.dataset.auvessiaResponsive = 'true';
      table.classList.add('auvessia-size-table');

      if (headings.length >= 5) {
        table.classList.add('auvessia-size-table--wide');
      }

      const rows = table.tBodies.length
        ? Array.from(table.tBodies).flatMap((body) =>
            Array.from(body.rows)
          )
        : Array.from(table.rows).slice(1);

      rows.forEach((row) => {
        Array.from(row.cells).forEach((cell, index) => {
          cell.dataset.label = headings[index] || '';
        });
      });

      const shell =
        table.closest('.rte-table-wrapper') || table.parentElement;

      shell?.classList.add('auvessia-size-table-shell');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      enhanceSizeTables,
      { once: true }
    );
  } else {
    enhanceSizeTables();
  }

  document.addEventListener(
    'shopify:section:load',
    enhanceSizeTables
  );
})();